import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'Login',
    component: lazyLoad("LoginPage")
  },
  {
    path: '/set_password',
    name: 'SetPassword',
    component: lazyLoad("SetPassword")
  },
  {
    path: '/member',
    component: lazyLoad("Member/Base"),
    children: [
      {
        path: '',
        name: 'MemberStation',
        component: lazyLoad("Member/Station")
      },
      {
        path: 'revenue',
        name: 'MemberRevenue',
        component: lazyLoad("Member/RevenueCalendar")
      },
      {
        path: 'information',
        name: 'MemberInformation',
        component: lazyLoad("Member/Information")
      },
      {
        path: 'notifications',
        name: 'MemberNotifications',
        component: lazyLoad("Member/Notifications")
      },
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
